import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Grid, IconButton } from '@mui/material';
import React from 'react';

import WsColors from '../../WsColors';

interface EditCommonComponentProps {
  onClose: () => void;
  onConfirm: () => void;
}

const EditCommonComponent: React.FC<EditCommonComponentProps> = ({ onClose, onConfirm }) => {
  return (
    <Grid container display="flex" justifyContent="end" mt={0.5}>
      <IconButton onClick={onClose} sx={{ borderRadius: 1.5 }}>
        <CloseIcon />
      </IconButton>
      <IconButton onClick={onConfirm} sx={{ borderRadius: 1.5, color: WsColors.TheBlues500 }}>
        <DoneIcon />
      </IconButton>
    </Grid>
  );
};

export default EditCommonComponent;
